module.exports = THEMES_CONFIG;